// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".law_firm_description-module__item--2Bmrp{padding-bottom:25px;display:block;max-width:100%;word-break:break-word}@media screen and (max-width: 62.5625em){.law_firm_description-module__item--2Bmrp{padding:0 15px 25px}}.law_firm_description-module__separator--couYu{border:0 solid #c6ced5;margin:50px 0px;background-color:#c6ced5;height:1px}.law_firm_description-module__block--1dirD{width:100%;padding:20px 0px;text-align:center;margin-top:-83px}.law_firm_description-module__title--1jXD5{font-size:12px;text-transform:uppercase;font-weight:700;padding:5px 15px;background-color:#f9fafb;padding:0px 20p}\n", ""]);
// Exports
exports.locals = {
	"item": "law_firm_description-module__item--2Bmrp",
	"separator": "law_firm_description-module__separator--couYu",
	"block": "law_firm_description-module__block--1dirD",
	"title": "law_firm_description-module__title--1jXD5"
};
module.exports = exports;
